// PriceLevelReducer.js — Manufacturer Module, Phase 5, Steps 1, 3, 4 & 7-8.
// Backs the Price Levels settings screen, ProductForm.jsx's per-level price
// fields, and the Low Stock alerts screen. Wired into rootReducer.js as
// `priceLevel`.

const initialState = {
  levels: [],
  productPriceValues: [],
  lowStockItems: [],
  loading: false,
  actionLoading: false,
  lowStockLoading: false,
  error: null
};

const PriceLevelReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'FETCH_PRICE_LEVELS_REQUEST':
      return { ...state, loading: true, error: null };
    case 'FETCH_PRICE_LEVELS_SUCCESS':
      return { ...state, loading: false, levels: action.payload, error: null };
    case 'FETCH_PRICE_LEVELS_FAILURE':
      return { ...state, loading: false, error: action.payload };

    case 'CREATE_PRICE_LEVEL_REQUEST':
    case 'UPDATE_PRICE_LEVEL_REQUEST':
    case 'DELETE_PRICE_LEVEL_REQUEST':
    case 'REORDER_PRICE_LEVELS_REQUEST':
      return { ...state, actionLoading: true, error: null };

    case 'CREATE_PRICE_LEVEL_SUCCESS':
      return {
        ...state,
        actionLoading: false,
        levels: action.payload ? [...state.levels, action.payload] : state.levels
      };

    case 'UPDATE_PRICE_LEVEL_SUCCESS':
      return {
        ...state,
        actionLoading: false,
        levels: state.levels.map((l) => (l.id === action.payload?.id ? { ...l, ...action.payload } : l))
      };

    case 'DELETE_PRICE_LEVEL_SUCCESS':
      return {
        ...state,
        actionLoading: false,
        levels: state.levels.filter((l) => l.id !== action.payload)
      };

    case 'REORDER_PRICE_LEVELS_SUCCESS':
      return { ...state, actionLoading: false, levels: action.payload };

    case 'CREATE_PRICE_LEVEL_FAILURE':
    case 'UPDATE_PRICE_LEVEL_FAILURE':
    case 'DELETE_PRICE_LEVEL_FAILURE':
    case 'REORDER_PRICE_LEVELS_FAILURE':
      return { ...state, actionLoading: false, error: action.payload };

    case 'FETCH_PRODUCT_PRICE_VALUES_REQUEST':
      return { ...state, error: null };
    case 'FETCH_PRODUCT_PRICE_VALUES_SUCCESS':
      return { ...state, productPriceValues: action.payload };
    case 'FETCH_PRODUCT_PRICE_VALUES_FAILURE':
      return { ...state, productPriceValues: [] };
    case 'CLEAR_PRODUCT_PRICE_VALUES':
      return { ...state, productPriceValues: [] };

    case 'FETCH_MANUFACTURER_LOW_STOCK_REQUEST':
      return { ...state, lowStockLoading: true };
    case 'FETCH_MANUFACTURER_LOW_STOCK_SUCCESS':
      return { ...state, lowStockLoading: false, lowStockItems: action.payload };
    case 'FETCH_MANUFACTURER_LOW_STOCK_FAILURE':
      return { ...state, lowStockLoading: false, error: action.payload };

    default:
      return state;
  }
};

export default PriceLevelReducer;
